module.exports = __webpack_public_path__ + "static/media/AB_iPhoneX_Bing.aba780ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile_header/AB_iPhoneX_Bing.png
// module id = 538
// module chunks = 0